import { Messaging } from '@theslipio/snippet';

export const ChatDemo = ({ primaryColor, profilePic, name }) => {
  return (
    <Messaging isDemo name={name} image={profilePic} color={primaryColor} />
  );
}
